module.exports = __webpack_public_path__ + "static/media/7.46019226.jpg";